module.exports = __webpack_public_path__ + "media/img/bg-criteria-52e470332000161c9788db1bc6b62cc0.png";